import { useEffect, useState } from "react";
import api from "@/lib/api";

const TYPE_LABEL = { product_change: "Product change", product_approval: "Product approval", vendor_application: "New vendor", return: "Return" };
const FILTERS = [["all", "All"], ["product_approval", "Products"], ["product_change", "Changes"], ["vendor_application", "Vendors"], ["return", "Returns"]];

export default function AdminActionCenter({ onGo }) {
  const [items, setItems] = useState([]);
  const [f, setF] = useState("all");
  useEffect(() => { api.get("/admin/action-center").then((r) => setItems(r.data)).catch(() => {}); }, []);
  const shown = f === "all" ? items : items.filter((i) => i.type === f);

  return (
    <div>
      <h2 className="font-serif text-4xl tracking-tighter">Action Center.</h2>
      <p className="text-muted-foreground mt-1">{items.length} action{items.length !== 1 ? "s" : ""} require attention.</p>

      <div className="flex gap-2 flex-wrap mt-5 mb-6">
        {FILTERS.map(([k, l]) => {
          const c = k === "all" ? items.length : items.filter((i) => i.type === k).length;
          return (
            <button key={k} onClick={() => setF(k)}
              className={`px-3 py-1.5 border font-mono text-[10px] uppercase tracking-widest ${f === k ? "bg-foreground text-background border-foreground" : "border-foreground/30 hover:border-foreground"}`}>
              {l} ({c})
            </button>
          );
        })}
      </div>

      {shown.length === 0 ? (
        <p className="font-serif text-2xl text-muted-foreground">Nothing needs attention. 🎉</p>
      ) : (
        <div className="space-y-3">
          {shown.map((i, idx) => (
            <div key={idx} className="border border-foreground p-4 flex items-center justify-between gap-4">
              <div className="min-w-0">
                <p className="font-mono text-[9px] uppercase tracking-widest text-[hsl(var(--accent))]">{TYPE_LABEL[i.type] || i.type}</p>
                <p className="font-serif text-xl mt-0.5 truncate">{i.title}</p>
                <p className="text-sm text-muted-foreground truncate">{i.subtitle}</p>
              </div>
              <button onClick={() => onGo(i.target?.tab || "products")} className="bg-foreground text-background px-4 py-2 text-xs font-mono uppercase hover:bg-[hsl(var(--accent))] shrink-0">Review →</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
